if (!customElements.get('header-search')) {
  customElements.define(
    'header-search',
    // eslint-disable-next-line no-undef
    class HeaderSearch extends window.BAO.CustomElement() {
      setupListeners () {
        super.setupListeners()

        if (this.hasEl('trigger')) {
          this.els.trigger.elements.forEach(trigger => {
            this.listeners.add(trigger, 'click', this.handleTrigger.bind(this))
          })
        }

        this.externalEls.trigger?.elements.forEach(pageTriggerEl => {
          this.listeners.add(
            pageTriggerEl,
            'click',
            this.handleTrigger.bind(this),
          )
        })

        if (this.dataset.searchContext === 'mobile-menu') {
          this.listeners.add(this, 'click', this.handleMenuTrigger.bind(this))
          this.listeners.add(this, 'focus', this.handleMenuTrigger.bind(this))
        }

        window.addEventListener(
          'headerSearch::closed',
          this.handleClose.bind(this),
        )

        this.listeners.add(document.body, 'focus', this.handleClose.bind(this))

        this.listeners.add(document, 'keyup', this.handleEscape.bind(this))

        window.BAO.eventBus.addEventListener(
          window.BAO.EVENTS.DRAWER.CLOSED,
          this.handleClose.bind(this),
        )

        window.BAO.eventBus.addEventListener(
          window.BAO.EVENTS.DRAWER.OPENED,
          this.handleClose.bind(this),
        )

        this.listeners.add(
          this.els.form.element,
          'submit',
          this.handleSubmit.bind(this),
        )
      }

      normalizeSearchQuery (q) {
        return (q ?? '').trim().replace(/\s+/g, ' ')
      }

      handleSubmit (event) {
        const normalizedQuery = this.normalizeSearchQuery(this.els.input.element.value)

        this.els.input.element.value = normalizedQuery

        window.theme.autocomplete.eventBus.publish(
          window.theme.autocomplete.events.TRACKING.SUBMIT_SEARCH,
          { query: normalizedQuery },
        )
      }

      handleTrigger (event) {
        this.openDropdown()

        this.isActive = true
      }

      openDropdown () {
        const externalDropdown = document.querySelector(
          '[data-header-search-external-el="dropdown"]',
        )
        const mql = window.matchMedia('(width <= 1200px)')
        externalDropdown.setAttribute('open', 'true')
        document.body.style.overflow = 'hidden'
        document
          .querySelector('layout-header')
          .classList.remove('lyt-Header-Transparent')

        if (mql.matches) {
          externalDropdown
            .querySelector('[data-search-dropdown-el="input"]')
            .focus()
        } else {
          setTimeout(() => {
            document
              .querySelector('[data-search-dropdown-external-el="input"]')
              .focus()
          }, 100)
        }
      }

      handleMenuTrigger (event) {
        if (
          (this.closest('.drw-Drawer-menu') && this.isActive) ||
          this.dataset.searchContext !== 'mobile-menu'
        ) {
          return
        }

        this.openDropdown()

        this.isActive =
          this.els.form.element.getAttribute('aria-hidden') === 'true'
      }

      handleClose (event) {
        this.isActive = false
      }

      // IOS Hack from Nike to open the keyboard when the search is opened
      focusAndOpenKeyboard (el, timeout) {
        if (!timeout) {
          timeout = 100
        }
        if (el) {
          // Align temp input element approximately where the input element is
          // so the cursor doesn't jump around
          const __tempEl__ = document.createElement('input')
          __tempEl__.style.position = 'absolute'
          __tempEl__.style.top = `${el.offsetTop + 7}px`
          __tempEl__.style.left = `${el.offsetLeft}px`
          __tempEl__.style.height = 0
          __tempEl__.style.opacity = 0
          // Put this temp element as a child of the page <body> and focus on it
          document.body.appendChild(__tempEl__)
          __tempEl__.focus()

          // The keyboard is open. Now do a delayed focus on the target element
          setTimeout(() => {
            el.focus()
            el.click()
            // Remove the temp element
            document.body.removeChild(__tempEl__)
          }, timeout)
        }
      }

      handleEscape (event) {
        if (event.key === 'Escape') {
          this.isActive = false
        }
      }

      hasEl (elementName) {
        return this.els[elementName] && this.els[elementName].exists
      }

      set isActive (boolean) {
        this._isActive = boolean
        this.els.form.element.setAttribute('aria-hidden', (!boolean).toString())
        this.els.trigger.element.setAttribute('aria-hidden', boolean.toString())

        if (boolean === true) {
          this.classList.add('hd-Search-active')
        } else {
          this.classList.remove('hd-Search-active')
        }

        document.body.dataset.searchActive = boolean.toString()

        const mql = window.matchMedia('(width <= 1200px)')

        if (mql.matches && boolean === true) {
          document.querySelector('[data-search-dropdown-el="input"]').focus()
          this.focusAndOpenKeyboard(
            document.querySelector('[data-search-dropdown-el="input"]'),
            0,
          )
        } else if (boolean === false) {
          this.els.input.element.blur()
        }
      }

      get isActive () {
        return this._isActive
      }
    },
  )
}
